import { render } from "./intercom-device.vue?vue&type=template&id=8969805a&scoped=true&ts=true"
import script from "./intercom-device.vue?vue&type=script&lang=ts"
export * from "./intercom-device.vue?vue&type=script&lang=ts"

import "./intercom-device.vue?vue&type=style&index=0&id=8969805a&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8969805a"]])

export default __exports__